import PropTypes from 'prop-types';
import { Typography, Box, TextField, Accordion, AccordionSummary, Stack, Autocomplete, Button, Grid, InputAdornment, IconButton } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import CurrencyInput from 'react-currency-input-field';
import SpacedRow from '../../reuseable-components/SpacedRow';
import Iconify from '../../reuseable-components/iconify/Iconify';

ProductUOMForm.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
  defaultUOMTypes: PropTypes.array,
  index: PropTypes.number,
  id: PropTypes.string
}

export default function ProductUOMForm({ formValue, setFormValue, defaultUOMTypes, id = "uomTypes" }) {

  const setValue = (field, value, index) => setFormValue(form => {
    if (!form[id]) form[id] = [{}];
    form[id][index][field] = value;
    return { ...form };
  });

  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)", padding: 2 }}>
    <Typography component="span">UOM Types {formValue[id]?.some(uom => uom.uomType) ? `(${formValue[id].filter(uom => uom.uomType)
      .map(uom => uom.uomType).join(", ")})` : ""}</Typography>
    <Stack sx={{ mx: 2, mb: 2 }} spacing={1}>
      {formValue[id].map((uom, index) => <Grid key={index} container>
        <SpacedRow  >
          <Box>
            <Typography variant="subtitle1">UOM Type</Typography>
            <Autocomplete
              fullWidth
              size="small"
              value={uom?.uomType ? { value: uom.uomType, label: uom.uomType } : null}
              isOptionEqualToValue={(val) => uom?.uomType === val?.value}
              onChange={(event, val) => setValue("uomType", typeof val === 'string' ? val : val?.label, index)}
              onInput={(e) => setValue("uomType", e.target.value, index)}
              options={uom?.uomType && !defaultUOMTypes.some(defaultUOM => defaultUOM.label === uom.uomType) ? [...defaultUOMTypes, { label: uom.uomType, value: uom.uomType }] : defaultUOMTypes}
              renderInput={(params) => <TextField {...params} placeholder="UOM Type" />}
            />
          </Box>
          <Box>
            <Typography variant="subtitle1">Price</Typography>
            <Box>
              <TextField
                name="price"
                size="small"
                placeholder="Please enter a price"
                value={uom?.price ?? 0}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  inputComponent: CurrencyInput,
                }}
                inputProps={{
                  onValueChange: (value) => setValue("price", value, index)
                }}
              />
            </Box>
          </Box>
          <Box>
            <Typography variant="subtitle1">UOM Amount</Typography>
            <TextField
              name="uomAmount"
              size="small"
              placeholder="Please enter an amount"
              value={uom?.uomAmount ?? 1}
              onChange={(e) => setValue("uomAmount", e.target.value.replace(/[^0-9]/, ""), index)}
            />
          </Box>
          <Box>
            <Typography variant="subtitle1">Alternative SKU</Typography>
            <TextField
              name="name"
              size="small"
              sx={{ width: "calc(100% - 40px)" }}
              placeholder="Enter Alternative SKU"
              fullWidth
              value={uom?.alternativeVendorItemId ?? ""}
              onChange={(e) => setValue("alternativeVendorItemId", e.target.value, index)}
            />
            <IconButton disableRipple color="error" onClick={() => setFormValue(form => {
              form[id] = form[id].filter((uom, uomIndex) => uomIndex !== index);
              return { ...form };
            })}>
              <DeleteOutline />
            </IconButton>
          </Box>
        </SpacedRow>
      </Grid>)}

      <Box alignSelf="center">
        <Button
          variant="contained"
          startIcon={<Iconify icon="eva:plus-fill" />}
          sx={{ mt: 2 }}
          onClick={() => setFormValue(form => {
            form[id] = [...(form[id] ?? []), {}];
            return { ...form };
          })}
          color="primary"
          size="medium">
          <Typography> Add UOM Type</Typography>
        </Button>
      </Box>
    </Stack>
  </Box>;
}
